function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import buildParams from '../../internal/analytics/buildParams';
import { getDefaultRpcInstance } from '../../internal/rpc/defaultRpc';
import { v4 as uuid } from 'uuid';
const rpcMethodMap = {
    action: 'analyticsAction',
    link: 'analyticsLink',
    modal: 'analyticsModal',
    track: 'analyticsTrack',
    viewed: 'analyticsViewed'
};
const method = (analyticsMethodName)=>{
    return (config, eventName, parameters)=>{
        var _config_analytics, _config__internal_observability_analytics, _config__internal_observability;
        if (!config || ((_config_analytics = config.analytics) === null || _config_analytics === void 0 ? void 0 : _config_analytics.disabled)) {
            return;
        }
        // This dual Reporting config is just temporary.
        const currentParams = config._tmp_dualReporting ? _object_spread_props(_object_spread({}, parameters), {
            _tdr_id: uuid()
        }) : parameters;
        const injectedMethod = (_config__internal_observability = config._internal_observability) === null || _config__internal_observability === void 0 ? void 0 : (_config__internal_observability_analytics = _config__internal_observability.analytics) === null || _config__internal_observability_analytics === void 0 ? void 0 : _config__internal_observability_analytics[analyticsMethodName];
        if (injectedMethod) {
            injectedMethod(config, eventName, buildParams(config, currentParams));
            if (!config._tmp_dualReporting) {
                return;
            }
        }
        var _config_rpc;
        const rpcClient = (_config_rpc = config.rpc) !== null && _config_rpc !== void 0 ? _config_rpc : getDefaultRpcInstance().client;
        const rpcMethod = rpcMethodMap[analyticsMethodName];
        const eventNameWithPotentialDualReporting = config._tmp_dualReporting ? `_tdr.${eventName}` : eventName;
        rpcClient.call(rpcMethod, // @ts-expect-error - TS2345 - Argument of type '[Readonly<{ service?: string | undefined; project: ProjectName; page?: string | undefined; pageViewToken?: string | undefined; release?: string | undefined; userId?: string | undefined; ... 5 more ...; _tmp_dualReporting?: boolean | undefined; }>, string, AnalyticsParams<...> | undefined]' is not assignable to parameter of type 'ObservabilityRpcMethods[{ readonly action: "analyticsAction"; readonly link: "analyticsLink"; readonly modal: "analyticsModal"; readonly track: "analyticsTrack"; readonly viewed: "analyticsViewed"; }[TMethod]]["args"]'. | Type '[Readonly<{ service?: string | undefined; project: ProjectName; page?: string | undefined; pageViewToken?: string | undefined; release?: string | undefined; userId?: string | undefined; ... 5 more ...; _tmp_dualReporting?: boolean | undefined; }>, string, AnalyticsParams<...> | undefined]' is not assignable to type '[config: Readonly<{ service?: string | undefined; project: ProjectName; page?: string | undefined; pageViewToken?: string | undefined; release?: string | undefined; userId?: string | undefined; ... 5 more ...; _tmp_dualReporting?: boolean | undefined; }> | null, eventName: string, parameters?: { ...; } | undefined]'. | Type at position 2 in source is not compatible with type at position 2 in target. | Type 'AnalyticsParams<T> | undefined' is not assignable to type '{ [key: string]: unknown; client_id?: undefined; created?: undefined; event_id?: undefined; event_name?: undefined; action_name?: undefined; analytics_ua?: undefined; cid?: undefined; domain?: undefined; ... 8 more ...; viewed_name?: undefined; } | undefined'. | Type 'AnalyticsParams<T>' is not assignable to type '{ [key: string]: unknown; client_id?: undefined; created?: undefined; event_id?: undefined; event_name?: undefined; action_name?: undefined; analytics_ua?: undefined; cid?: undefined; domain?: undefined; ... 8 more ...; viewed_name?: undefined; } | undefined'. | Type '{ page: string; release: string; service: string; project: ProjectName; error_message: string; error_handled: string; error_issue_id: string; error_issue_url: string; } | { [key: string]: unknown; ... 16 more ...; viewed_name?: undefined; }' is not assignable to type '{ [key: string]: unknown; client_id?: undefined; created?: undefined; event_id?: undefined; event_name?: undefined; action_name?: undefined; analytics_ua?: undefined; cid?: undefined; domain?: undefined; ... 8 more ...; viewed_name?: undefined; } | undefined'.
        config, eventNameWithPotentialDualReporting, currentParams);
    };
};
/**
 * @see https://sail.stripe.me/observability/api/useAnalytics#action
 */ export const action = method('action');
/**
 * @see https://sail.stripe.me/observability/api/useAnalytics#link
 */ export const link = method('link');
/**
 * @see https://sail.stripe.me/observability/api/useAnalytics#modal
 */ export const modal = method('modal');
/**
 * @see https://sail.stripe.me/observability/api/useAnalytics#track
 */ export const track = method('track');
/**
 * @see https://sail.stripe.me/observability/api/useAnalytics#viewed
 */ export const viewed = method('viewed');

//# sourceMappingURL=analytics.client.js.map